import styled from 'styled-components';

export const MainColumn = styled.div`
  max-width: 100%;

  &:first-child {
    flex: 1;
  }
`;
